module.exports = __webpack_public_path__ + "src/assets/img/page2/a6479006d427ce617b911e1ef3d51845.png";